







































































































































































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import axios from "axios";
	import storeToken from "@/stores/modules/token";
	import {Token, User} from "@/models";

	@Component({
		components: {
		}
	})
	export default class CrudEssenceAchatSyntheseEssenceAchats extends Vue {
		@Stored(() => storeToken) private token: Token;

		private menu = false;
		private menuEnd = false;
		private menuVendu = false;
		private menuEndVendu = false;

		total:number = 0.0;
		totalBordRoute:number = 0.0;
		totalSurPied:number = 0.0;
		totalM3:number = 0.0;
		totalBordRouteM3:number = 0.0;
		totalSurPiedM3:number = 0.0;
		totalTonne:number = 0.0;
		totalBordRouteTonne:number = 0.0;
		totalSurPiedTonne:number = 0.0;

		DateDebutAppro: string = '';
		DateFinAppro: string = '';
		totalAppro:number = 0.0;

		DateDebutVendu: string = '';
		DateFinVendu: string = '';
		totalVendu:number = 0.0;

		public async mounted(): Promise<void> {
			let firstDayYear = new Date(new Date().getFullYear(), 0, 1, 1);
			this.DateDebutAppro = firstDayYear.toISOString().slice(0, 10)
			this.DateFinAppro = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)

			this.DateDebutVendu = firstDayYear.toISOString().slice(0, 10)
			this.DateFinVendu = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)

			await this.LoadInfosAchats();
			await this.LoadInfosAppro();
			await this.LoadInfosVente();
		}

		private async LoadInfosAchats(): Promise<void> 
		{
			await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/achats/total_bord_route?token=" + this.token.id, {}).then(async response => {
				this.total = await response.data["Total"];
				this.totalBordRoute = await response.data["BordDeRoute"];
				this.totalSurPied = await response.data["SurPied"];

				this.totalM3 = await response.data["TotalM3"];
				this.totalBordRouteM3 = await response.data["BordDeRouteM3"];
				this.totalSurPiedM3 = await response.data["SurPiedM3"];

				this.totalTonne = await response.data["TotalTonne"];
				this.totalBordRouteTonne = await response.data["BordDeRouteTonne"];
				this.totalSurPiedTonne = await response.data["SurPiedTonne"];
			});
		}

		private async LoadInfosAppro(): Promise<void> 
		{
			await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/approvisionnements/totaux/" + this.DateDebutAppro + "/" + this.DateFinAppro + "?token=" + this.token.id, {}).then(async response => {
				this.totalAppro = await response.data["Total"];
			});
		}

		private async LoadInfosVente(): Promise<void> 
		{
			await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/ventes/totaux/" + this.DateDebutVendu + "/" + this.DateFinVendu + "?token=" + this.token.id, {}).then(async response => {
				this.totalVendu = await response.data["Total"];
			});
		}

		@Watch('DateDebutAppro')
		@Watch('DateFinAppro')
		private async valueApproWatcher(): Promise<void> {
			await this.LoadInfosAppro();
		}

		@Watch('DateDebutVendu')
		@Watch('DateFinVendu')
		private async valueVenduWatcher(): Promise<void> {
			await this.LoadInfosVente();
		}

		get computedDateStartFormatted () : string {
        	return this.formatDate(this.DateDebutAppro)
      	}

		get computedDateEndFormatted () : string {
        	return this.formatDate(this.DateFinAppro)
      	}

		get computedDateStartVenduFormatted () : string {
        	return this.formatDate(this.DateDebutVendu)
      	}

		get computedDateEndVenduFormatted () : string {
        	return this.formatDate(this.DateFinVendu)
      	}

		private formatDate (date) {
			if (!date) return null

        	const [year, month, day] = date.split('-')
        	return `${day}/${month}/${year}`
      	}

	}
